var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('router-view',{attrs:{"name":"header"}}),_c('div',{staticClass:"main-wrapper"},[_c('router-view',{attrs:{"name":"aside"}}),_c('router-view',{staticClass:"root-content"})],1),_c('router-view',{attrs:{"name":"footer"}}),_c('notifications')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }